import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui'
import logger from '#util/logger'

let $overlayRootElement = null

/**
 * Class to toggle the application overlay on/off
 */
class AppOverlayService {

  /**
   * Toggles the application overlay on
   */
  static show() {
    if ($overlayRootElement === null) {
      $overlayRootElement = document.querySelector('#app-overlay')
    }

    if (!($overlayRootElement.offsetWidth > 0 || $overlayRootElement.offsetHeight > 0)) {
      return new Promise((resolve) => {
        logger('showing Global Overlay', 'debug')()

        const overlaySequence = [{
          e: $overlayRootElement,
          p: { opacity: 1 },
          o: { duration: 150, easing: 'linear', display: 'block' },
        }]

        Velocity.RunSequence(overlaySequence)

        const $loadingIcon = $overlayRootElement.querySelector('.loading-gif')
        const loadingIconSequence = [{
          e: $loadingIcon,
          p: { scale: 1 },
          o: {
            duration: 350,
            easing: [500, 20],
            complete: () => resolve(),
          },
        }]

        Velocity.RunSequence(loadingIconSequence)
      })
    }
  }

  /**
   * Toggles the application overlay off.
   */
  static hide() {
    if ($overlayRootElement === null) {
      $overlayRootElement = document.querySelector('#app-overlay')
    }
    return new Promise((resolve) => {
      logger('hiding Global Overlay', 'debug')()
      const $loadingIcon = $overlayRootElement.querySelector('.loading-gif')
      const hideSequence = [{
        e: $loadingIcon,
        p: { opacity: 0 },
        o: {
          duration: 75,
          easing: 'easeOutCubic',
        },
      }, {
        e: $overlayRootElement,
        p: { opacity: 0 },
        o: {
          duration: 350,
          display: 'none',
          easing: 'linear',
        },
      }, {
        e: $loadingIcon,
        p: { opacity: 1 },
        o: {
          duration: 0,
          complete: () => resolve(),
        },
      }]
      Velocity.RunSequence(hideSequence)
    })
  }
}

export default AppOverlayService
